import React, { useState, useEffect, useContext } from "react";
import { Modal, Button } from "react-bootstrap";
import Select from "react-select";

import DatePicker from "react-date-picker";
import "react-calendar/dist/Calendar.css";
import "react-date-picker/dist/DatePicker.css";

import SuccessPopupModal from "../../components/SuccessPopupModal";
import { useAuth } from "../../../Context/AuthContext";
import { addUpdateBlog, GetBlogModal } from "../../../Services/Blog/BlogApi";
import { ERROR_MESSAGES } from "../../components/GlobalMassage";
import { addUpdateProjectCat, getProjectCat } from "../../../Services/Project Category/ProjectCategoryApi";
import { isVideoSource } from "../../../mediaHelpers";

const MAX_IMAGE_SIZE_BYTES = 200 * 1024; // 200KB
const MAX_VIDEO_SIZE_BYTES = 5 * 1024 * 1024; // 5MB

const ProjectAddUpdateModal = ({
  show,
  onHide,
  setIsAddUpdateActionDone,
  modelRequestData,
}) => {
  const [modelAction, setModelAction] = useState("");
  const [error, setErrors] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState();

  const { setLoader, user } = useAuth();
  const [stateOption, setStateOption] = useState([]);
  const [companyOption, setCompanyOption] = useState([]);
  const [districtOption, setDistrictOption] = useState([]);
  const [talukaOption, setTalukaOption] = useState([]);
  const [villageOption, setVillageOption] = useState([]);

  const [projectObj, setProjectObj] = useState({
    projectCatKeyID: null,
    projectCatName: null,
    projectCatImage: null,
    
  });


  useEffect(() => {
    // debugger
    if (modelRequestData?.Action === "Update") {
      if (modelRequestData?.ProjectCatKeyID !== null) {
        GetBlogModalData(modelRequestData.ProjectCatKeyID);
      }
    }
  }, [modelRequestData?.Action]);

  const AddCustomerBtnClick = async () => {
    // debugger
    let isValid = false;

    if (
      projectObj.projectCatName === null ||
      projectObj.projectCatName === undefined ||
      projectObj.projectCatName === "" ||
      projectObj.projectCatImage === null ||
      projectObj.projectCatImage === undefined ||
      projectObj.projectCatImage === ""
   
    ) {
      setErrors(true);
      isValid = true;
    } else {
      setErrors(false);
      isValid = false;
    }

    const apiParam = {
      projectCatName: projectObj.projectCatName,
      projectCatImage: projectObj.projectCatImage,
      projectCatKeyID: projectObj.projectCatKeyID,
      
    };
    if (!isValid) {
      AddUpdateCustomerData(apiParam);
    }
  };

  const AddUpdateCustomerData = async (apiParam) => {
    // debugger
    setLoader(true);
    try {
      let url = "/addUpdateProjectCat"; // Default URL for Adding Data

      const response = await addUpdateProjectCat(url, apiParam);
      if (response) {
        if (response?.data?.statusCode === 200) {
          setLoader(false);
          // debugger
          setShowSuccessModal(true);
          setModelAction(
            modelRequestData.Action === null ||
              modelRequestData.Action === undefined
              ? "Project Added Successfully!"
              : "Project Updated Successfully!"
          ); //Do not change this naming convention

          setIsAddUpdateActionDone(true);
        } else {
          setLoader(false);
          setErrorMessage(response?.response?.data?.errorMessage);
        }
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const handleImageChange = (e, fieldName) => {
    const file = e.target.files[0];
    if (file) {
      const isVideo = file.type.startsWith("video/");
      const isImage = file.type.startsWith("image/");

      if (!isVideo && !isImage) {
        alert("Only image or video files are allowed.");
        e.target.value = "";
        return;
      }
      if (isImage && file.size > MAX_IMAGE_SIZE_BYTES) {
        alert("Image size should be 200KB or less.");
        e.target.value = "";
        return;
      }
      if (isVideo && file.size > MAX_VIDEO_SIZE_BYTES) {
        alert("Video size should be 5MB or less.");
        e.target.value = "";
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        setProjectObj((prev) => ({
          ...prev,
          [fieldName]: reader.result, // set base64
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = (fieldName) => {
    setProjectObj((prev) => ({
      ...prev,
      [fieldName]: null,
    }));
  };
  const GetBlogModalData = async (id) => {
    setLoader(true);
    if (id === undefined) {
      return;
    }

    try {
      const data = await getProjectCat(id);
      if (data?.data?.statusCode === 200) {
        setLoader(false);

        console.log(data, "dsadas324r");
        const ModelData = data.data.responseData.data; // Assuming data is an array
        console.log(ModelData.Title, "dsaiygd9s7a6ydsadsa");

        setProjectObj({
          ...projectObj,
          projectCatKeyID: ModelData.ProjectCatKeyID,
          projectCatName: ModelData.ProjectCatName,
          projectCatImage: ModelData.projectCatImage,
         
        });
      } else {
        setLoader(false);
        // Handle non-200 status codes if necessary
        console.error("Error fetching data: ", data?.data?.statusCode);
      }
    } catch (error) {
      setLoader(false);
      console.error("Error in Customer : ", error);
    }
  };

  console.log(projectObj.Title, "kdjsgauhydsa");

  const closeAllModal = () => {
    onHide();
    setShowSuccessModal(false);
  };

  const handleDescriptionChange = (htmlContent) => {
    setProjectObj((obj) => ({
      ...obj,
      blogDescription: htmlContent,
    }));
  };

  const handleDateChange = (event) => {
    const selectedDate = event.target.value; // Gets the publishDate in "YYYY-MM-DD" format
    setProjectObj((prev) => ({
      ...prev,
      publishDate: selectedDate,
    }));
  };
  return (
    <>
    {show && <div className="custom-backdrop" />}
      <Modal
        size="md"
        show={show}
        style={{ zIndex: 1300 }}
        onHide={onHide}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <>
            <h4 className="text-center project-main-mode text-dark">
              {modelRequestData?.Action !== null
                ? "Update Project Category"
                : modelRequestData?.Action === null
                ? "Add Project Category"
                : ""}
            </h4>
          </>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "55vh", overflow: "overlay" }}>
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-12 mb-2">
                <div>
                  <label htmlFor="clientName" className="form-label">
                   Project Category Name
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="clientName"
                    placeholder="Enter Project Category Name"
                    aria-describedby="Employee"
                    value={projectObj.projectCatName}
                    onChange={(e) => {
                      setErrorMessage(false);
                      let inputValue = e.target.value;
                      // If the input is empty or starts with a space, prevent the space
                      if (
                        inputValue.length === 0 ||
                        (inputValue.length === 1 && inputValue === " ")
                      ) {
                        inputValue = "";
                      }
                      // Remove unwanted characters (keeping spaces that aren't at the start)
                      const cleanedValue = inputValue.replace(
                        /[^a-zA-Z0-9\s]/g,
                        ""
                      );

                      // Trim leading spaces while keeping internal spaces
                      const trimmedValue = cleanedValue.trimStart();

                      // Capitalize the first letter and keep the rest as is
                      const updatedValue =
                        trimmedValue.charAt(0).toUpperCase() +
                        trimmedValue.slice(1);

                      setProjectObj((prev) => ({
                        ...prev,
                        projectCatName: updatedValue,
                      }));
                    }}
                  />

                  {error &&
                  (projectObj.projectCatName === null ||
                    projectObj.projectCatName === undefined ||
                    projectObj.projectCatName === "") ? (
                    <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-12 mb-2">
                <label className="form-label">Project Image/Video:
                <p className="small">Note:-(Image upto 200kb) </p>
                </label>
                {projectObj.projectCatImage ? (
                  <div
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    {isVideoSource(projectObj.projectCatImage) ? (
                      <video
                        src={projectObj.projectCatImage}
                        controls
                        style={{
                          maxWidth: "100%",
                          maxHeight: "200px",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                        }}
                      />
                    ) : (
                      <img
                        src={projectObj.projectCatImage}
                        alt="Feature Preview"
                        style={{
                          maxWidth: "100%",
                          maxHeight: "200px",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                        }}
                      />
                    )}
                    <button
                      type="button"
                      onClick={() => handleRemoveImage("projectCatImage")}
                      style={{
                        position: "absolute",
                        top: "5px",
                        right: "5px",
                        background: "rgba(255,255,255,0.8)",
                        border: "none",
                        borderRadius: "50%",
                        cursor: "pointer",
                        fontWeight: "bold",
                        padding: "2px 8px",
                      }}
                    >
                      ×
                    </button>
                  </div>
                ) : (
                  <input
                    type="file"
                    accept="image/*,video/*"
                    onChange={(e) => handleImageChange(e, "projectCatImage")}
                    className="form-control"
                  />
                )}
              </div>
            </div>

            {/* <div className="row"> */}
          </div>

          {/* </div> */}
        </Modal.Body>
        <Modal.Footer>
          <Button className="rts-btn border bg-transparent" onClick={onHide}>
            Close
          </Button>
          <Button
            type="submit"
            style={{
              color: "white",
              backgroundColor: "#blue",
              borderColor: "#f08143",
            }}
            className=" rts-btn    text-center"
            onClick={() => AddCustomerBtnClick()}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
      {showSuccessModal && (
        <SuccessPopupModal
          show={showSuccessModal}
          onHide={() => closeAllModal()}
          setShowSuccessModal={setShowSuccessModal}
          modelAction={modelAction}
        />
      )}
    </>
  );
};

export default ProjectAddUpdateModal;
